import { useCollapse } from '../composables/useCollapse';

const toggleDirective = {
  beforeMount(el, binding) {
    const { registerCollapse, toggleCollapseState, getCollapseState } =
      useCollapse();

    // Ensure the state exists for this ID
    registerCollapse(binding.value);

    const syncAttrs = () => {
      const stateRef = getCollapseState(binding.value);
      const expanded = !!stateRef?.value;
      el.setAttribute('aria-expanded', String(expanded));
      el.classList.toggle('collapsed', !expanded);
      el.classList.toggle('not-collapsed', expanded);
    };

    const clickHandler = () => {
      toggleCollapseState(binding.value);
      syncAttrs();
    };

    // Initialize ARIA + classes on first render
    syncAttrs();

    el.addEventListener('click', clickHandler);
    el._vueClickHandler = clickHandler;
  },

  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      const { registerCollapse } = useCollapse();
      registerCollapse(binding.value);
    }
  },

  unmounted(el) {
    if (el._vueClickHandler) {
      el.removeEventListener('click', el._vueClickHandler);
    }
  },
};

export default toggleDirective;
